// FILE: src/components/Header.jsx
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './header.css';
import logo from "../assets/finallogo1.png"; // Replace with your actual logo image

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Auto-close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <motion.header
      className="header"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="header-container">
        <Link to="/" className="logo-tagline">
          <motion.img
            src={logo}
            alt="oceancruise"
            className="logo"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          />
          {/* <motion.span
            className="tagline"
            initial={{x:-30, opacity:0}}
            animate={{x:0, opacity: 1 }}
            transition={{delay:0.4, duration:0.6}}
            >
              Navigate Your Future

          </motion.span> */}
        </Link>

        <nav className="nav desktop-only">
          <motion.div whileHover={{ scale: 1.05 }}><Link to="/">Home</Link></motion.div>
          <motion.div whileHover={{ scale: 1.05 }}><Link to="/About">About Us</Link></motion.div>
          <motion.div whileHover={{ scale: 1.05 }}><Link to="/services">Services</Link></motion.div>
          <motion.div whileHover={{ scale: 1.05 }}><Link to="/contactus">Contact Us</Link></motion.div>
        </nav>

        <div className="mobile-toggle mobile-only" onClick={toggleMenu}>
          ☰
        </div>
      </div>

      <AnimatePresence>
        {menuOpen=== true && (
          <motion.div
            className="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div whileTap={{ scale: 0.95 }}><Link to="/">Home</Link></motion.div>
            <motion.div whileTap={{ scale: 0.95 }}><Link to="About">About</Link></motion.div>
            <motion.div whileTap={{ scale: 0.95 }}><Link to="/Services">Services</Link></motion.div>
            <motion.div whileTap={{ scale: 0.95 }}><Link to="/contactus">Contact</Link></motion.div>

            <div className="contact-info">
              <p>📞 +91-84385 39518</p>
              <p>✉️ info@Oceancruise.in</p>
              <div className="social-links">
                <a href="#" target="_blank" rel="noopener noreferrer">🌐 Website</a>
                <a href="#" target="_blank" rel="noopener noreferrer">📘 Facebook</a>
                <a href="#" target="_blank" rel="noopener noreferrer">📷 Instagram</a>
                <a href="#" target="_blank" rel="noopener noreferrer">💬 WhatsApp</a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
